// @vendors
import React from 'react'
import { useTranslation } from 'react-i18next';

const PaymentView = () => {
    const { t } = useTranslation();

    return (
        <div className='w-full h-[400px] flex items-center justify-center'>
            <p className='flex text-[30px] text-gray-400 text-center pl-[20%] pr-[20%]'>
                {t("userProfile.comingSoon")}
            </p>
        </div>
    )
}

export default PaymentView